import {SELECT_VALUE} from "../constants/VATItems";

export const calcGrossValue = (netValue, vatOptionValue, optionOtherValue) => {

    if (vatOptionValue === null) return;

    if (isNaN(netValue)) return;

    if (vatOptionValue === SELECT_VALUE.DIFFRENT_VAT) {
        return;
    }

    if(vatOptionValue === SELECT_VALUE.CANCEL) {
        vatOptionValue = 0;
    }

    if (vatOptionValue === SELECT_VALUE.OTHER) {
        vatOptionValue = optionOtherValue;
    }

    let vatMultipler = vatOptionValue / 100

    let newGrossValue = netValue + netValue * vatMultipler;
    if (isNaN(newGrossValue)) return

    return Math.round(newGrossValue * 100) / 100;
}


export const calcNetValue = (grossValue, vatOptionValue, optionOtherValue) => {
    if (vatOptionValue === null) return;
    if (isNaN(grossValue)) return

    if (vatOptionValue === SELECT_VALUE.DIFFRENT_VAT) {
        return;
    } else if(vatOptionValue === SELECT_VALUE.CANCEL) {
        vatOptionValue = 0;
    } else if (vatOptionValue === SELECT_VALUE.OTHER) {
        vatOptionValue = optionOtherValue;
    }

    const vatMultipler = vatOptionValue / 100;

    let newNetValue = grossValue;
    if (vatMultipler !== 0) newNetValue = Math.round((grossValue / (1 + vatMultipler)) * 100) / 100;

    if (isNaN(newNetValue)) return

    return newNetValue;
}